// extracted by mini-css-extract-plugin
export default {"divider":"DateDivider_divider__K4bRL","container":"DateDivider_container__Nl7YK"};